import * as uuidv4 from 'uuid/v4';

import { Telemetry } from '../../../commonInfra/services/Telemetry';
import { SearchNoResultEvent, TelemetryEvents, SearchTermUpdatedEvent, SearchResultClickedEvent, SearchEventSource } from '../../../common/telemetryEvents/TelemetryEvents';

interface ISearchTelemetry {
  clearSearchFlowId: () => void;
  startSearchFlow: () => void;
  sendSearchTermUpdatedEvent: (eventSource: SearchEventSource, searchTerm: string) => void;
  endSearchFlowWithNoResultEvent: (eventSource: SearchEventSource, searchTerm: string) => void;
  sendSearchResultClickedEvent: (event: Omit<SearchResultClickedEvent, 'searchFlowId'>) => void;
}

class SearchTelemetry implements ISearchTelemetry {

  private searchFlowId: string = '';

  public startSearchFlow = () => {
    this.searchFlowId = uuidv4();
  }

  public clearSearchFlowId = () => {
    this.searchFlowId = '';
  }

  public sendSearchTermUpdatedEvent = (eventSource: SearchEventSource, searchTerm: string) => {
    Telemetry.sendEvent<SearchTermUpdatedEvent>({
      type: TelemetryEvents.SearchTermUpdated,
      eventSource,
      searchTerm,
      searchFlowId: this.searchFlowId
    });
  };

  public endSearchFlowWithNoResultEvent = (eventSource: SearchEventSource, searchTerm: string) => {

    if (this.searchFlowId === '') { return; }
    Telemetry.sendEvent<SearchNoResultEvent>({
      type: TelemetryEvents.SearchNoResult,
      eventSource,
      searchTerm,
      searchFlowId: this.searchFlowId
    });
    this.clearSearchFlowId();
  }

  public sendSearchResultClickedEvent = (event: Omit<SearchResultClickedEvent, 'searchFlowId'>) => {
    Telemetry.sendEvent<SearchResultClickedEvent>({...event, searchFlowId: this.searchFlowId});
    this.clearSearchFlowId();
  }
}

export const searchTelemetry: ISearchTelemetry = new SearchTelemetry();
